import { createFileRoute } from '@tanstack/react-router'
import { InspectionsScreen } from '@/features/inspections/routes/inspections-screen'

export const Route = createFileRoute('/inspections')({ component: InspectionsScreen })
